export function isParent(
  parentFullPath: string,
  childFullPath: string
): boolean {
  const childRelPaths = childFullPath.split('/');
  const parentRelPaths = parentFullPath.split('/');

  if (parentRelPaths.length < childRelPaths.length) {
    let isParent = true;
    parentRelPaths.forEach((parentRelPath, index) => {
      isParent = isParent && childRelPaths[index] === parentRelPath;
    });
    return isParent;
  } else {
    return false;
  }
}
